import { Badge } from '@/components/ui/badge';
import { formatQuantidade } from '@/lib/utils/formatters';
import type { SituacaoTotal } from '@/services/Documentos';

interface SituacoesDoModeloProps {
  situacoes?: SituacaoTotal[];
  carregando: boolean;
}

/** "Autorizadas" com 1 vira "1 autorizada"; o servidor manda o nome no plural. */
function rotuloDaSituacao(situacao: string, total: number): string {
  const nome = situacao.toLowerCase();
  return total === 1 && nome.endsWith('as') ? nome.slice(0, -1) : nome;
}

export function SituacoesDoModelo({ situacoes, carregando }: SituacoesDoModeloProps) {
  if (carregando || !situacoes || situacoes.length === 0) return null;

  return (
    <span className="inline-flex items-center gap-1" data-testid="situacoes-do-modelo">
      {situacoes.map(situacao => (
        <Badge key={situacao.situacao} variant="outline" className="text-xs font-normal">
          {formatQuantidade(situacao.total)} {rotuloDaSituacao(situacao.situacao, situacao.total)}
        </Badge>
      ))}
    </span>
  );
}
